export const imageAccommodation = {
  breadcrumbCurrent: "Logo der Unterkunft",
  heading: "Das Logo Ihres Inserats",
  subtitle:
    "Laden Sie das Logo hoch, das dieses Inserat kennzeichnet. Erlaubte Formate: PNG, JPG, SVG · max. 5 MB.",
  savedLogoAlt: "Gespeichertes Logo",
  activeBadge: "Aktives Logo",
  change: "Ändern",
  drop: {
    release: "Hier ablegen",
    newLogo: "Neues Logo",
    uploadLogo: "Logo hochladen",
    dragOr: "Ziehen oder",
    clickLink: "klicken",
    formats: "PNG · JPG · SVG · max. 5 MB",
  },
  importButton: "Logo aus anderem Inserat importieren",
  crop: {
    removeImage: "Bild entfernen",
    tip: "Verschieben und passen Sie den Ausschnitt an. Format 2:1 (ideal für horizontale Logos).",
    saving: "Wird gespeichert…",
    save: "Logo speichern",
  },
  actions: {
    cancel: "Abbrechen",
  },
  applyModal: {
    title: "Auf andere Inserate anwenden?",
    subtitle: "Wählen Sie die Inserate aus, auf die dieses Logo kopiert werden soll.",
    logoAlt: "Logo",
    selectAll: "Alle auswählen",
    progress: "{done}/{total} werden angewendet…",
    skip: "Überspringen",
    applying: "Wird angewendet…",
    applyToBtn: "Auf {count} Inserat anwenden | Auf {count} Inserate anwenden",
  },
  importModal: {
    title: "Logo importieren",
    subtitle: "Wählen Sie das Logo eines anderen Inserats, das hier verwendet werden soll.",
    loading: "Inserate werden geladen…",
    empty: "Noch kein Inserat hat ein Logo.",
    progress: "Logo wird importiert…",
    importing: "Wird importiert…",
  },
  defaultListingName: "Inserat",
  toasts: {
    invalidFormat: "Ungültiges Format. Verwenden Sie PNG, JPG oder SVG.",
    fileTooLarge: "Die Datei überschreitet das Limit von {max} MB.",
    selectBeforeSave: "Wählen und passen Sie ein Logo an, bevor Sie speichern.",
    propertyNotFound: "Die zu diesem Inserat gehörende Unterkunft wurde nicht gefunden.",
    saveSuccess: "Logo erfolgreich gespeichert",
    saveError: "Fehler beim Speichern des Logos.",
    listingLoadError: "Die Daten des Inserats konnten nicht geladen werden.",
    applySuccess:
      "Logo erfolgreich auf {count} Inserat angewendet | Logo erfolgreich auf {count} Inserate angewendet",
    applyError:
      "Anwendung auf {count} Inserat fehlgeschlagen | Anwendung auf {count} Inserate fehlgeschlagen",
    listingsLoadError: "Die Inserate konnten nicht geladen werden.",
    propertyNotFoundImport: "Die Unterkunft für dieses Inserat wurde nicht gefunden.",
    importSuccess: 'Logo von „{name}“ erfolgreich importiert',
    importError: "Fehler beim Importieren des Logos.",
  },
};
